export const weeklyActiveUsers = [
  { userId: 'u3', weeklyPosts: 9, weeklyReplies: 46 },
  { userId: 'u2', weeklyPosts: 8, weeklyReplies: 21 },
  { userId: 'u1', weeklyPosts: 7, weeklyReplies: 38 },
  { userId: 'u4', weeklyPosts: 6, weeklyReplies: 52 },
  { userId: 'u9', weeklyPosts: 5, weeklyReplies: 27 },
  { userId: 'u5', weeklyPosts: 4, weeklyReplies: 33 },
  { userId: 'u7', weeklyPosts: 4, weeklyReplies: 12 },
  { userId: 'u8', weeklyPosts: 3, weeklyReplies: 29 },
];

export const siteStats = [
  { key: 'members', label: '注册成员', value: '128,460', icon: 'ri-group-line' },
  { key: 'topics', label: '兴趣话题', value: '32,918', icon: 'ri-chat-quote-line' },
  { key: 'replies', label: '累计回复', value: '1,204,337', icon: 'ri-discuss-line' },
  { key: 'categories', label: '内容分区', value: '6', icon: 'ri-layout-grid-line' },
];

export const hotKeywords = ['阳台改造', '一人食', '舒芙蕾', '环岛骑行', '国产剧', '极简生活', '家庭服务器', '京都红叶'];